// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"521":"errors-404","795":"error-403","852":"errors-500","945":"dashboard","954":"configurations","966":"login"}[chunkId] || chunkId) + "-legacy." + {"521":"28637c94","795":"b8ea1912","852":"1df3b7b3","905":"1532ba10","945":"dca8a3a1","954":"8edaf091","966":"5c183807"}[chunkId] + ".js";
};